export default __webpack_public_path__ + "static/media/error-dark.6de97f7b.svg";